import { render, staticRenderFns } from "./HeaderPf.vue?vue&type=template&id=0a718a4e&scoped=true&"
import script from "./HeaderPf.vue?vue&type=script&lang=js&"
export * from "./HeaderPf.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPf.vue?vue&type=style&index=0&id=0a718a4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a718a4e",
  null
  
)

export default component.exports